import { useState } from "react"
import "./App.css"
import TaskSpotLight from "./Components/TaskSpotLight/TaskSpotLight";
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors, DragOverlay } from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import AddTask from "./Components/AddTask/AddTask"
function App() {


  const [task, setTask] = useState([
    {id: 1, title: "Add Test 1", codeLanguage: ["HTML"], status: "todo"},
    {id: 2, title: "Add Test 2", codeLanguage: ["CSS"], status: "pending"},
    {id: 3, title: "Add Test 3", codeLanguage: ["HTML"], status: "finish"}
  ])
  const [activeTask, setActiveTask] = useState(null)

  const addTask = title => {
    setTask(task => [
      ...task,
      {
        id: task.length + 1,
        title: title.title,
        codeLanguage: title.codeLanguage,
        status: title.status}])
  }

  const handleDeleteTask = (id) =>{
    setTask(prev => prev.filter(task => task.id !== id))
  }

  const handleDragEnd = ({ active, over }) => {


  if (!over) return

  setTask(tasks => {
    const activeIndex = tasks.findIndex(t => t.id === active.id)
    const activeTask = tasks[activeIndex]

    const overStatus = over.data.current.status
    if (activeTask.status !== overStatus) {
      const updated = [...tasks]
      updated[activeIndex] = {
        ...activeTask,
        status: overStatus
      }
      return updated
    }
    const overIndex = tasks.findIndex(t => t.id === over.id)
    return arrayMove(tasks, activeIndex, overIndex)
  })
}



  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })

  )

  return (
    <div className='App'>
      <h1>My Task</h1>
      <DndContext
        sensors={sensors}
        onDragEnd={handleDragEnd}
        collisionDetection={closestCenter}
      >
        <AddTask onSubmit={ addTask }/>
        <TaskSpotLight task={task} onDeleteTask={handleDeleteTask}/>
      </DndContext>
    </div>
  )
}

export default App;